import styled from 'styled-components'

export const Info = styled.div`
  color: var(--text-secondary);
  /* body/sm/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
`
